import { render, staticRenderFns } from "./ShortcutsModal.vue?vue&type=template&id=39df4987&"
import script from "./ShortcutsModal.vue?vue&type=script&lang=js&"
export * from "./ShortcutsModal.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutsModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports